



























































import { Component, Vue, Prop } from 'vue-property-decorator';
import LazyImage from '@/componentsV2/atoms/LazyImage/LazyImage.vue';

@Component({
  components: {
    LazyImage
  }
})
export default class ImageSpecialCoinPreview extends Vue {
  @Prop({ default: '172px' }) size?: string;
  @Prop(String) link?: string;
}
